// Add this constant somewhere above your component
const FILE_TYPES = [
    { value: "contract_files", label: "Contract" },
    { value: "amendment_files", label: "Amendment" },
    { value: "proposal_files", label: "Proposal" },
    { value: "coi_files", label: "Certificate of Insurance (COI)" },
    { value: "business_license_files", label: "Business License" },
    { value: "city_document_files", label: "City Document" },
    { value: "receipt_files", label: "Receipt" },
    { value: "logo_files", label: "Logo" },
    { value: "signage_files", label: "Signage" },
    { value: "team_pic_files", label: "Team Pic" },
    { value: "marketing_pic_files", label: "Marketing Pic" },
    { value: "other_files", label: "Other / Misc" }
];

export default FILE_TYPES;